<template>
  <transition name="dialog-fade">
     <div class="statusBox">
       <div class="contentBox">
         <Icon class="closeBtn" type="ios-close" @click="handleClose"></Icon>
         <div class="contentTop">
           <p class="tit">{{tips}}</p>
           <p class="tips">切换为学生身份登录后方可查看</p>
         </div>
         <div class="btnBot">
           <div class="switchBtn" @click="handleSubmit">切换为学生</div>
         </div>
       </div>
       <back-login-dialog v-if="isBackShow" :backType="switchType"></back-login-dialog>
     </div>
  </transition>
</template>

<script>
  import backLoginDialog from '@/components/dialog/backLoginDialog.vue'
  import Cookies from 'js-cookie'
  export default {
    props: {
      switchType: {
        type: String
      }
    },
    data() {
      return {
        isBackShow: false,
        tips: '企业'
      }
    },
    created() {
      const val = Cookies.get('login_type')
      this.tips = `当前登录身份是${val == 'school' ? '高校管理人员' : val == 'channel' ? '主办方' : '企业'}`
    },
    components: {
      backLoginDialog
    },
    methods: {
      handleClose() {
        this.$emit('handleClose')
      },
      handleSubmit() {
        this.isBackShow = true
      },
      handleCancel() {
        this.isBackShow = false
      },
      handleDailog(){
        this.$emit('handleDailog',true)
      }
    }
  }
</script>

<style lang="less" scoped>
  .statusBox {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(0,0,0,.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9;
    .contentBox {
      width: 464px;
      height: 309px;
      background-color: #FFFFFF;
      border-radius: 4px;
      display: flex;
      flex-direction: column;
      position: relative;
      .closeBtn {
        width: 36px;
        height: 36px;
        color: rgba(255,255,255,0.8);
        position: absolute;
        right: -10px;
        top: -30px;
        font-size: 34px;
        font-weight: bold;
      }
      .closeBtn:hover {
        cursor: pointer;
        color: rgba(255,255,255,1);
      }
      .contentTop {
        height: 177px;
        background-color: #F4F9FF;
        background-image: url(../../assets/img_切换.png);
        background-size: 152px 136px;
        background-repeat: no-repeat;
        background-position: right bottom;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-left: 48px;
        box-sizing: border-box;
        border-radius: 4px 4px 0 0;
        .tit {
          font-size: 18px;
          color: #17233D;
          line-height: 24px;
        }
        .tips {
          font-size: 14px;
          color: #808695;
          margin-top: 12px;
        }
      }
      .btnBot {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        .switchBtn {
          width: 312px;
          height: 44px;
          line-height: 44px;
          text-align: center;
          background-color: #1477EF;
          border-radius: 4px;
          font-size: 16px;
          color: #FFFFFF;
          &:hover {
            cursor: pointer;
            background-color: @color-btn-hover;
          }
          &:active {
            cursor: pointer;
            background-color: @color-btn-active;
          }
        }
      }
    }
  }
  /deep/ .ivu-modal-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  // 进入动画
  .dialog-fade-enter-active {
    animation: dialog-fade-in 0.4s;
  }
  // 离开动画
  .dialog-fade-leave-active {
    animation: dialog-fade-out 0.4s;
  }

  @keyframes dialog-fade-in {
    0% {
      transform: translate3d(0, -20px, 0);
      opacity: 0;
    }
    100% {
      transform: translate3d(0, 0, 0);
      opacity: 1;
    }
  }

  @keyframes dialog-fade-out {
    0% {
      transform: translate3d(0, 0, 0);
      opacity: 1;
    }
    100% {
      transform: translate3d(0, -20px, 0);
      opacity: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dialog/switchLoginStatus.vue